// extracted by mini-css-extract-plugin
export var orderSummary = "_ol-0";
export var showMoreLessButton = "_ol-1";